/* Consumable Depot — Trash Bag Finder
   Maps the four shopper answers to a recommended collection + message.
   Collection handles below MUST match the collections you create in admin
   (see SETUP-GUIDE.md → Collections). Edit the maps if your handles differ. */
(function () {
  // bin size value -> { handle, label }
  var SIZE_MAP = {
    small:  { handle: '7-10-gal-trash-bags',  label: '7\u201310 Gallon' },
    medium: { handle: '12-16-gal-trash-bags', label: '12\u201316 Gallon' },
    large:  { handle: '20-30-gal-trash-bags', label: '20\u201330 Gallon' },
    xlarge: { handle: '55-gal-trash-bags',    label: '55 Gallon' }
  };
  var COLOR_MAP = {
    clear: { handle: 'clear-trash-bags', label: 'Clear' },
    black: { handle: 'black-trash-bags', label: 'Black' },
    any:   { handle: '',                 label: 'Clear or Black' }
  };
  // waste type -> density guidance (purely advisory text)
  var WASTE_TEXT = {
    light: 'a high-density bag (great for paper, office and restroom waste)',
    heavy: 'a low-density bag (built for heavier, sharper, mixed and outdoor waste)',
    mixed: 'a low-density bag for mixed loads'
  };

  function init(root) {
    var form = root.querySelector('[data-cd-finder-form]');
    if (!form) return;
    var result = root.querySelector('[data-cd-finder-result]');
    var textEl = root.querySelector('[data-cd-finder-text]');
    var goBtn  = root.querySelector('[data-cd-finder-go]');
    var quoteWrap = root.querySelector('[data-cd-finder-quote]');

    function run() {
      var size  = form.querySelector('[name="bin"]').value;
      var waste = form.querySelector('[name="waste"]').value;
      var color = form.querySelector('[name="color"]').value;
      var cases = form.querySelector('[name="cases"]').value;
      if (!size || !color) { return; }

      var s = SIZE_MAP[size] || SIZE_MAP.medium;
      var c = COLOR_MAP[color] || COLOR_MAP.any;
      var target = c.handle && color !== 'any' ? '/collections/' + c.handle : '/collections/' + s.handle;
      // Prefer the gallon collection so shoppers land on the right size first.
      target = '/collections/' + s.handle;

      var msg = 'We recommend <strong>' + s.label + ' ' + c.label + '</strong> bags';
      if (waste && WASTE_TEXT[waste]) { msg += ' \u2014 look for ' + WASTE_TEXT[waste] + '.'; }
      else { msg += '.'; }

      if (textEl) textEl.innerHTML = msg;
      if (goBtn) {
        goBtn.href = target;
        goBtn.textContent = 'Shop ' + s.label + ' bags';
      }
      // Nudge to quote when buying a lot.
      var big = (cases === '8plus' || cases === 'pallet');
      if (quoteWrap) quoteWrap.style.display = big ? 'inline-flex' : 'none';

      if (result) {
        result.classList.add('is-visible');
        result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); run(); });
    var trigger = root.querySelector('[data-cd-finder-submit]');
    if (trigger) trigger.addEventListener('click', function (e) { e.preventDefault(); run(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cd-finder]').forEach(init);
  });
})();

